import type { JSX, PropsWithChildren, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarImage, Icon, Text } from '@/_components';
import type { SvgIconProps } from '@/types';

export type SectionHeadingProps = {
  text: string | JSX.Element | null | ReactNode;
  icon?: string | SvgIconProps;
  titleRightSlot?: JSX.Element | null | ReactNode;
  rightSlot?: JSX.Element | null | ReactNode;
  className?: string;
};

export function SectionHeading({
  icon,
  text,
  titleRightSlot,
  rightSlot,
  className,
}: PropsWithChildren<SectionHeadingProps>) {
  return (
    <header className={twMerge('flex flex-1 flex-wrap items-center justify-between gap-2', className)}>
      <div className="flex max-w-full items-center gap-x-2">
        {icon && (
          <Avatar size="lg" className="flex items-center justify-center p-2" legacyBgColor>
            {typeof icon === 'string' ? (
              <AvatarImage src={icon} className="bg-cover" />
            ) : (
              <Icon icon={icon} className="w-6" />
            )}
          </Avatar>
        )}
        {typeof text === 'string' ? (
          <Text
            as="h4"
            className="text-accent flex-1 truncate text-lg font-extrabold whitespace-nowrap lg:text-lg dark:text-white"
          >
            {text}
          </Text>
        ) : (
          text
        )}
        {titleRightSlot}
      </div>
      {rightSlot && <div className="flex-end">{rightSlot}</div>}
    </header>
  );
}
